import { createRequest } from '../../Api';
import get from 'lodash/get';
import i18n from '../../i18n';

export const REQUEST_ERROR = 'CONFIGURATION_REQUEST_ERROR';
export const SEND_REQUEST_OFFER = 'OFFER_SEND_REQUEST_OFFER';
export const RECEIVE_REQUEST_OFFER = 'OFFER_RECEIVE_REQUEST_OFFER';
export const RESET_REQUEST_OFFER = 'OFFER_RESET_REQUEST_OFFER';
export const RESET_ERROR = 'OFFER_RESET_ERROR';

export const createRequestError = (e) => ({
  type: REQUEST_ERROR,
  error: e,
});

export const receiveRequestOffer = (response) => ({
  type: RECEIVE_REQUEST_OFFER,
  response,
});

export const resetRequestOffer = () => ({
  type: RESET_REQUEST_OFFER,
});

export const resetError = () => ({
  type: RESET_ERROR,
});

export const sendRequestOffer = (data) => async (dispatch, getState) => {
  const { request } = createRequest();
  const { code } = getState().Configuration.configuration;
  data.configurationCode = code;
  try {
    const response = await request({
      method: 'post',
      url: `/frontendapi/receiveoffers/request`,
      data,
    });

    const price = get(response, 'data.price', 0);
    const dataLayer = window.dataLayer;
    if (dataLayer) {
      dataLayer.push({
        event: 'Submit-Request',
        language: i18n.language,
        value: price,
      });
    }

    dispatch(receiveRequestOffer(response));
  } catch (e) {
    dispatch(createRequestError(e));
  }
};
